export default {
  name: "Mixed Department Vehicle Check",
  description: "General-purpose vehicle check for mixed-use teams.",
  required: ["Name", "LicensePlate", "Mileage"],
  fields: [
    { key: "Name", label: "Name", type: "text", required: true },
    { key: "Date", label: "Date", type: "date" },
    { key: "Department", label: "Department", type: "text" },
    { key: "LicensePlate", label: "Vehicle Number Plate", type: "text", required: true },
    { key: "Mileage", label: "Mileage", type: "number", required: true },
    { key: "TripPurpose", label: "Reason for Trip", type: "text" },
    { key: "Destination", label: "Destination", type: "text" },
    { key: "Cleanliness", label: "Cleanliness of Vehicle", type: "text" },
    { key: "Damage", label: "Any Visible Damage", type: "text" },
    { key: "Supplies", label: "Equipment / Stock Check", type: "text" },
    { key: "Notes", label: "Additional Notes", type: "textarea" }
  ],
  photos: true
};
